export const SET_EMBED = 'SET_EMBED';
export const SET_EDIT = 'SET_EDIT';
export const SET_SENTSURVEYS = 'SET_SENTSURVEYS';
export const SET_INITIALSTATE = 'SET_INITIALSTATE';